import React from 'react';

import styles from './BulletIcon.module.scss';

/**
 * No more looking up font awesome stuff! Just use the same things T.T   
 * 
 *  @param {string} bulletType - can be "rightCaret, leftLaret, upCaret, downCaret openCircle, ellipsis" 
*/
export const BulletIcon = ({
    bulletType="openCircle"
}) => {
    return (
        <span className={styles["bullet-icon"]}>
            {bulletType === "rightCaret" && <i className="far fa-caret-right" />}
            {bulletType === "upCaret" && <i className="far fa-caret-up" />}
            {bulletType === "downCaret" && <i className="far fa-caret-down" />}
            {bulletType === "leftCaret" && <i className="far fa-caret-left" />}
            {bulletType === "openCircle" && <i className="far fa-circle" style={{fontSize: "10px"}} />}
            {bulletType === "ellipsis" && <i className="far fa-ellipsis-h-alt" />}
        </span>
    )
}